import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="field_loading">
      <img className="img_loading" src="img/loading.png" alt="" />
    </div>
  );
}

export default Loading;
